export {
    default as IconProvider,
    IIconProviderProps,
    IconContext,
} from './icon-provider';
